import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-black text-center my-10" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "flex flex-col gap-5 my-5" }
const _hoisted_4 = {
  key: 0,
  class: "mt-10 mb-5"
}
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "text-primary-violet font-normal text-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-idea" }, null, -1)
const _hoisted_8 = { class: "my-3 flex flex-col gap-5" }
const _hoisted_9 = { class: "text-xl font-bold text-center" }
const _hoisted_10 = {
  key: 0,
  class: "w-full flex flex-col items-center justify-between"
}
const _hoisted_11 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_12 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_13 = { class: "h-full border-0 w-auto h-12 items-center justify-center flex mt-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "w-full flex flex-col"
}

import { IonFooter, IonButton, IonToolbar, IonIcon, IonContent, IonList, IonItem, IonRadio, IonRadioGroup, IonLabel, loadingController } from "@ionic/vue"
  import { computed, onMounted, ref, watch } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import { useResourcesStore } from "@/store/resources"
  import { useUserStore } from "@/store/user"
  import { chunk, filter, shuffle, includes, reduce, each, values, max, map } from "lodash"
  import { addDays, format, parse, differenceInDays, isValid } from "date-fns"
  import * as jwt from "@/utils/jwt"
  import ProgressBar from "@/components/template/ProgressBar.vue"
  import { chevronBack, chevronForward } from "ionicons/icons"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionPage',
  setup(__props) {

  const resourcesStore = useResourcesStore()
  const userStore = useUserStore()
  const route = useRoute()
  const router = useRouter()
  const percent = ref(0)
  const isTieBreaker = ref(false)
  const tieBreakerValue = ref("")
  const worksonaTie = ref<string[]>([])
  const page = ref(0)
  const results = ref<{ [key: string]: number }>({
    explorer: 0,
    innocent: 0,
    innovator: 0,
    inventor: 0,
    jester: 0,
    philosopher: 0,
    realist: 0,
    supporter: 0,
    sweetheart: 0,
    warrior: 0,
    ruler: 0,
    rebel: 0,
  })
  const type = computed(() => (route.params.type as string) || "")
  const description = computed(() => resourcesStore.surveyDescriptions[type.value as string])
  const listCondition = computed(() => {
    if (isTieBreaker.value) {
      return filter(resourcesStore.survey, (obj) => obj.id === "worksona_tie_breaker")
    } else {
      return filter(resourcesStore.survey, (obj) => obj.id !== "worksona_tie_breaker")
    }
  })
  const survey = computed(() => chunk(shuffle(listCondition.value), 5))
  /**
   * get the option based on set
   * @param type of field
   */
  const getScale = (type: string) => {
    const matches = type.match(/scale\[(.*?)\]/)
    if (matches && matches[1]) {
      return matches[1].split(",")
    } else return []
  }
  /**
   * generate css to a field if the type is scale
   * @param type type of field
   * @param index index of the field
   */
  const getScaleCSS = (type: string, index: number) => {
    const scales = getScale(type)
    if (scales.length == 5) {
      if (index === 0 || index === 4) {
        return "w-12 h-12"
      } else if (index === 1 || index === 3) {
        return "w-10 h-10"
      } else return "w-8 h-8"
    } else return "w-12 h-12"
  }
  /**
   * next page when suvery is paginated
   */
  const onNext = () => {
    const isSuccess = reduce(
      survey.value[page.value],
      (result: any, data: any) => {
        const answer = (data.question.answer as boolean | string | number) || false
        return answer && result
      },
      true
    )
    if (isSuccess) {
      percent.value = ((page.value + 1) / survey.value.length) * 100
      page.value += 1
      IonContent.scrollToTop()
    }
  }
  /**
   * go bact to prev page
   */
  const onPrev = () => {
    page.value -= 1
    percent.value = ((page.value + 1) / survey.value.length) * 100
  }
  /**
   * save to database before redirecting
   */
  const onSave = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Saving answers...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    const nextTake = addDays(new Date(), 90)
    userStore.customerDetails.profile.worksona = { ...userStore.customerDetails.profile.worksona, ...results.value, last_take: format(nextTake, "dd/MM/yyyy HH:mm:ss") }
    await userStore.saveCustomerDetails(jwt.default.generateNBF())
    loading.dismiss()
    if (type.value === "worksona") {
      const valueResult = values(results.value)
      const maxValue = max(valueResult)
      const keysMap = map(results.value, (val, key) => (val === maxValue ? key : false))
      const filteredKeys = filter(keysMap, (val) => val !== false)
      router.push(`/worksona/result/${filteredKeys[0]}`)
    }
  }
  /**
   * validate all information of survey before saving
   */
  const onSubmit = () => {
    if (type.value === "worksona" && !isTieBreaker.value) {
      each(survey.value, (val) => {
        each(val, (data) => {
          const worksonaType = data.question.type || ""
          if (worksonaType) {
            results.value[worksonaType] = ((results.value[worksonaType] as number) || 0) + ((data.question.answer as number) || 0)
          }
        })
      })
      const valueResult = values(results.value)
      const maxValue = max(valueResult)
      const keysMap = map(results.value, (val, key) => (val === maxValue ? key : false))
      const filteredKeys = filter(keysMap, (val) => val !== false)
      if (filteredKeys.length > 1) {
        worksonaTie.value = filteredKeys as string[]
        isTieBreaker.value = true
        page.value = 0
      } else onSave()
    } else if (type.value === "worksona" && isTieBreaker.value) {
      results.value[tieBreakerValue.value] += 1
      onSave()
    }
  }
  /**
   * initializing worksona questions
   * user will redirect if last take is not yet 90 days
   */
  const initWorksona = () => {
    if (userStore.customerDetails.profile.worksona.last_take !== "" && type.value === "worksona") {
      let lastTake = parse(userStore.customerDetails.profile.worksona.last_take, "dd/MM/yyyy HH:mm:ss", new Date())
      if (isValid(lastTake)) {
        if (lastTake.getFullYear() < 2020) {
          lastTake = parse(userStore.customerDetails.profile.worksona.last_take, "dd/MM/yy HH:mm:ss", new Date())
        }
        if (differenceInDays(lastTake, new Date()) > 0) {
          const dataWorksona = JSON.parse(JSON.stringify(userStore.customerDetails.profile.worksona))
          delete dataWorksona.last_take
          const valueResult = values(dataWorksona)
          const maxValue = max(valueResult)
          const keysMap = map(dataWorksona, (val, key) => (val === maxValue ? key : false))
          const filteredKeys = filter(keysMap, (val) => val !== false)
          router.push(`/worksona/result/${filteredKeys[0]}`)
        }
      }
    }
  }

  onMounted(async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    if (!type.value) {
      router.push("/")
    } else {
      await resourcesStore.retrieveSurvey(type.value as string)
      if (resourcesStore.survey.length === 0) {
        router.push("/not-found")
      }
      initWorksona()
    }
    loading.dismiss()
  })
  watch(
    () => userStore.customerDetails.profile.worksona.last_take,
    () => {
      initWorksona()
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(description).title), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(description).details, (detail) => {
          return (_openBlock(), _createElementBlock("div", {
            key: detail.label,
            class: "flex flex-col p-7 rounded-3xl my-4",
            style: _normalizeStyle({
        backgroundColor: `${detail.color}48`,
      })
          }, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(detail.label), 1),
            _createElementVNode("p", null, _toDisplayString(detail.description), 1)
          ], 4))
        }), 128)),
        _createElementVNode("div", _hoisted_3, [
          (_unref(description).progressLabel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(ProgressBar, {
                  percent: percent.value,
                  label: _unref(description).progressLabel
                }, null, 8, ["percent", "label"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(description).rule) + " ", 1),
            _createElementVNode("p", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_unref(description).tip), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(survey)[page.value], ({ question }) => {
            return (_openBlock(), _createElementBlock("div", {
              key: question.label,
              class: "w-full flex flex-col items-center justify-center gap-10 p-2"
            }, [
              _createElementVNode("h4", _hoisted_9, _toDisplayString(question.label), 1),
              (_unref(includes)(question.field, 'scale'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", null, _toDisplayString(getScale(question.field)[0]), 1),
                      _createElementVNode("p", null, _toDisplayString(getScale(question.field)[getScale(question.field).length - 1]), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getScale(question.field), (scale, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${scale}_${question.label}`,
                          class: "flex flex-col w-auto items-center justify-start"
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", {
                              class: _normalizeClass(getScaleCSS(question.field, index))
                            }, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["w-full h-full rounded-full", {
                      'bg-light-gray': question.answer !== index + 1,
                      'bg-primary-violet': question.answer === index + 1,
                    }]),
                                onClick: ($event: any) => (question.answer = index + 1)
                              }, null, 10, _hoisted_14)
                            ], 2)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (question.field === 'select-worksona')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_unref(IonList), { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRadioGroup), {
                            modelValue: tieBreakerValue.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tieBreakerValue).value = $event)),
                            name: "worksona-tie-breaker"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.option, (opt, typeBreaker) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `tie_${opt}`
                                }, [
                                  (_unref(includes)(worksonaTie.value, typeBreaker))
                                    ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(opt), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_unref(IonRadio), {
                                            slot: "end",
                                            value: typeBreaker,
                                            name: "worksona-tie-breaker"
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), { class: "ion-no-border" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "p-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButton), {
              slot: "start",
              disabled: page.value === 0,
              class: "text-primary",
              onClick: onPrev
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  slot: "icon-only",
                  icon: _unref(chevronBack)
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            (page.value < _unref(survey).length - 1)
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 0,
                  slot: "end",
                  onClick: onNext
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(chevronForward)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 1,
                  slot: "end",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})